import { ThemeSelectors } from '@at/design-system-foundation'
import styled, { css } from 'styled-components'

export const StyledNewFormActionArea = styled.section`
    ${({ theme }) => css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: ${theme.color.bgSurface.default};
        width: 100%;
        height: auto;
        min-height: 97px;
        padding: ${ThemeSelectors.getGridUnit(theme)};
        position: sticky;
        bottom: -16px;
        left: 0;
    `}
`
